import {Moon, Sun} from '@phosphor-icons/react';

import {useUserProfile} from '../api.js';
import useLocalStore from '../utils/useLocalStore.js';
import FeatureFlags from './FeatureFlags.jsx';
import ThemeSelect from './ThemeSelect.jsx';

export default function Settings() {
  const theme = useLocalStore(st => st.theme);
  const {data: user} = useUserProfile();

  return (
    <div className="mx-auto max-w-3xl px-4 pb-64 pt-4 desktop:mt-4">
      <div className="space-y-4">
        <h1 className="text-2xl font-bold text-base-content desktop:text-3xl">Settings</h1>

        <div className="bg-base-100 p-4 shadow-md">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <label className={`swap swap-rotate ${theme === 'light' ? 'swap-active' : ''}`}>
                <Sun size={24} className="swap-on" style={{fill: 'black'}} />
                <Moon size={24} className="swap-off" style={{fill: 'white'}} />
              </label>
              <label>Theme</label>
            </div>
            <ThemeSelect />
          </div>
        </div>

        {[
          'andrew@andrewzey.com',
          'astonmartin@example.com',
          'easterday@rpstrength.com',
          'marion.jeff@gmail.com',
        ].includes(user.email) ? (
          <div className="space-y-6 border-2 border-dashed border-base-200 bg-base-100 p-4">
            <h4 className="font-semibold">Internal Only</h4>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => {
                throw new Error('Testing Bugsnag error');
              }}
            >
              Throw test error
            </button>

            <FeatureFlags />
          </div>
        ) : null}
      </div>
    </div>
  );
}
